import { useDispatch, useSelector } from "react-redux";
import { useEffect, useCallback } from "react";
import toast from "react-hot-toast";
import { logOut } from "../redux/slice/authSlice";
import { useNavigate } from "react-router-dom";
import { checkoutDateSession } from "../utils/ckeckDateSession";
import { clearListMemberships } from "../redux/slice/membershipsSlice";

const useCheckSession = () => {
  const { isAuthenticated, token } = useSelector((state) => state.authReducer);

  const navigation = useNavigate();
  const dispatch = useDispatch();

  const validateSession = useCallback(() => {
    if (!token) return;

    const expired = checkoutDateSession(token);

    if (expired.expired) {
      navigation("/");
      dispatch(clearListMemberships());
      dispatch(logOut());
      toast.error("Su sesión terminó.\n Inicie una nueva cuando lo necesite.", {
        duration: 10000,
      });
    }
  }, [token, navigation, dispatch]);

  useEffect(() => {
    if (!isAuthenticated) return;
    validateSession();
    const interval = setInterval(() => {
      validateSession();
    }, 10000);

    return () => clearInterval(interval);
  }, [isAuthenticated, validateSession, token]);
};

export default useCheckSession;
